import { render, staticRenderFns } from "./PermissionSubGroups.vue?vue&type=template&id=50fd4b38&"
import script from "./PermissionSubGroups.vue?vue&type=script&lang=js&"
export * from "./PermissionSubGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports